module.exports = __webpack_public_path__ + "img/img3.3c139443.png";